module.exports = __webpack_public_path__ + "img/39_8.00600f1f.png";